import { fetchApi } from 'api/fetchApi'

export const fetchTeamoTokeIdApi = async () => {
  return await fetchApi<{ token: string; aid: number }>(
    '/promo/teamo/survey/user_token' as any
  )
}
